"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.niceJoin = niceJoin;
function niceJoin(items) {
  if (!items || items.length === 0) return '';
  if (items.length === 1) return items[0];
  if (items.length === 2) return "".concat(items[0], " and ").concat(items[1]);
  var lastItem = items[items.length - 1];
  var allButLast = items.slice(0, -1);
  return "".concat(allButLast.join(', '), ", and ").concat(lastItem);
}